import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
    return request({
        url: "/base/vehicleLabel/findByPage",
        method: "post",
        data
    });
}

/**
 * 删除车辆信息
 * @param {*} data
 */
export function DeleteVehicleLabelInfoById(data) {
    return request({
        url: "/base/vehicleLabel/deleteVehicleLabelInfoById",
        method: "post",
        data
    })
}

/**
 * 编辑车辆信息
 * @param {*} data
 */
export function SaveVehicleLabelInfo(data) {
    return request({
        url: "/base/vehicleLabel/saveVehicleLabelInfo",
        method: "post",
        data
    })
}

/**
 * 查询单个车辆信息
 * @param {*} data
 */
export function FindVehicleLabelInfoById(data) {
    return request({
        url: "/base/vehicleLabel/findVehicleLabelInfoById",
        method: "post",
        data
    })
}

/**
 * 查询单个车辆信息
 * @param {*} data
 */
export function CheckNameUniqueData(data) {
    return request({
        url: "/base/vehicleLabel/checkNameUniqueData",
        method: "post",
        data
    })
}




